import './style.css';
import '../../../style.css';

import React from 'react';
import Legend from './controls/legend';
import Segments from './controls/segments';
import WholeChart from './controls/whole-chart';

class Segment extends React.Component {
  onHover(hovered) {
    return this.props.onHover(hovered);
  }

  render() {
    let colour;
    const r = this.props.radius;
    const style = {
      transition: 'transform 300ms ease-out',
      transform: `scale(1${this.props.isHovered ? '.2' : ''})`
    };

    const o = this.props.offset;
    const a = o + this.props.angle;
    const lrg = this.props.angle <= Math.PI ? 0 : 1;

    const d = [
      'M',
      0,
      0,
      'L',
      Math.cos(o) * r,
      -(Math.sin(o) * r),
      'A',
      r,
      r,
      0,
      lrg,
      0,
      Math.cos(a) * r,
      -(Math.sin(a) * r),
      'L',
      0,
      0
    ].join(' ');

    if (this.props.colourOnHover && !this.props.isHovered) {
      colour = 'rgba(255,255,255, 0.1)';
    } else {
      ({ colour } = this.props);
    }

    return (
      <path
        style={style}
        d={d}
        fill={colour}
        stroke="white"
        strokeWidth={4}
        onClick={this.onHover.bind(this, true)}
        onMouseOver={this.onHover.bind(this, true)}
        onTouchStart={this.onHover.bind(this, true)}
        onTouchEnd={this.onHover.bind(this, false)}
        onMouseOut={this.onHover.bind(this, false)}
      />
    );
  }
}

Segment.defaultProps = {
  colour: 'gray',
  offset: 0,
  angle: 0,
  radius: 1,
  isHovered: false,
  onHover: () => {}
};

export default class extends React.Component {
  static displayName = 'PieChart';

  static defaultProps = {
    data: [],
    legend: false,
    hoverLabels: true
  };

  state = {
    hovered: -1
  };

  onHover = (hasLabel, idx, value) => {
    if (!value && idx === this.state.hovered) {
      this.setState({
        hovered: -1
      });
    }

    if (value && idx !== this.state.hovered) {
      return this.setState({
        hovered: idx
      });
    }
  };

  render() {
    const { onHover } = this;
    const { hovered } = this.state;
    const { data, hoverLabels, legend } = this.props;

    const columns = legend === true ? '50' : '100';
    const chart =
      data.length > 1 ? (
        <Segments data={data} hovered={hovered} onHover={onHover} hoverLabels={hoverLabels} />
      ) : (
        <WholeChart item={data[0]} hoverLabels={hoverLabels} />
      );

    return (
      <div className="bz-piechart bz-row">
        <div className={`bz-column bz-col-${columns}`}>
          <div className="chart-panel">
            <svg width="100%" height="100%" viewBox="0 0 1200 800">
              <g transform="translate(600 400)">{chart}</g>
            </svg>
          </div>
        </div>
        <Legend data={data} legend={legend} onHover={onHover} />
      </div>
    );
  }
}

export { Segment };
